import React, { Component } from "react";
import { Col, Row, FormGroup } from "react-bootstrap";
import CommonSelector from "../Common/CommonSelector";
import FormInputs from "../Common/FormInputs";

const FormErrors = ({ formErrors, fieldName }) => {
    const errorMessage = formErrors[fieldName];
    if (!errorMessage) return null;

    return (
        <div
            id={`${fieldName}Error`}
            className="row formErrors"
            aria-live="polite"
        >
            <p className="form-validation-error">{errorMessage}</p>
        </div>
    );
};

class ProjectInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            teamFocused: false,
            unSelectedTeamOpts: [],
        };
        this.handleProjectNameChange = this.handleProjectNameChange.bind(this);
        this.handleProjectTeamChange = this.handleProjectTeamChange.bind(this);
    }

    handleProjectNameChange(e) {
        if (e.target.type === "text") {
            this.props.handleProjectNameUpdate(e.target.value);
        }
    }

    handleProjectTeamChange(e) {
        const projectTeam = e.map((user) => user.value);
        this.props.handleProjectTeamUpdate(projectTeam);
    }

    handleProjectTeamInputChange = (inputValue) => {
        if (inputValue === "") return;
        const tempTeamOpts = this.props.userOptions.filter(
            (opt) =>
                !opt.checked &&
                opt.label.toLowerCase().includes(inputValue.toLowerCase())
        );
        this.setState({ unSelectedTeamOpts: tempTeamOpts });
    };

    resetOptions = (event, filterName) => {
        if (filterName === "team") {
            this.setState({ unSelectedTeamOpts: [] });
        } else {
            console.warn("no match for user attribute filter.");
        }
    };

    render() {
        const {
            projectName,
            projectTeam,
            userOptions,
            formErrors,
            inputClass_projectName,
            trans,
        } = this.props;

        const selectedTeam =
            projectTeam && userOptions.length > 0
                ? userOptions.filter((user) => projectTeam.includes(user.value))
                : [];

        const userFilterOptions = this.state.unSelectedTeamOpts || [];

        return (
            <Row>
                <Col md={{ span: 10, offset: 1 }}>
                    <FormGroup role="group" aria-labelledby="projectInformation_head">
                        <h4
                            id="projectInformation_head"
                            className="knoa-region"
                            tabIndex="-1"
                        >
                            {trans("project:projectInformation")}
                        </h4>

                        {/* Project Name */}
                        <Row className="row-with-error align-items-stretch">
                            <Col className="card-row-col-label" md={2}>
                                <label htmlFor="projectName" className="col-control-sr-label">
                                    {trans("project:projectName")} <span className="text-danger">*</span>
                                </label>
                            </Col>
                            <Col md={6} className="card-row-col-right">
                                <div className="input-with-error">
                                    <FormInputs
                                        ncols={["col-12"]}
                                        proprieties={[{
                                            type: "text",
                                            name: "projectName",
                                            className: inputClass_projectName,
                                            placeholder: "",
                                            value: projectName,
                                            onChange: this.handleProjectNameChange,
                                            id: "projectName",
                                            required: true,
                                            "aria-invalid": !!formErrors.projectName,
                                            "aria-describedby": formErrors.projectName ? "projectNameError" : undefined
                                        }]}
                                    />
                                    <div className="error-placeholder">
                                        <FormErrors formErrors={formErrors} fieldName="projectName" />
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        {/* Project Team Selector */}
                        <Row className="align-items-center">
                            <Col md={3} className="card-row-col-label">
                                <label htmlFor="projectTeamSelect" className="form-label">
                                    {trans("project:shareWithUsers")}
                                </label>
                            </Col>
                            <Col md={6} className="card-row-col-right">
                                <CommonSelector
                                    inputId="projectTeamSelect"
                                    style="typetosearch"
                                    componentLocation="normal"
                                    name="projectTeamSelect"
                                    placeholder={
                                        this.state.teamFocused ? "" : trans("common:typeToSearch")
                                    }
                                    value={selectedTeam}
                                    options={userFilterOptions}
                                    onChange={this.handleProjectTeamChange}
                                    onInputChange={this.handleProjectTeamInputChange}
                                    onMenuClose={(e) => this.resetOptions(e, "team")}
                                    onFocus={() => this.setState({ teamFocused: true })}
                                    onBlur={() => this.setState({ teamFocused: false })}
                                    isClearable
                                    isSearchable
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </Col>
            </Row>
        );
    }
}

export default ProjectInformation;